import config from "../config";
import handleResponse from "./helper";


export const competetiveService = {
	getCompetitors,
	getCompetitorById,
	getCompetitorProducts,
	getResourceTypes,
	getResourceTypeById,
	getResources,
	getCompetitorProductById,
	submitFeedback,
	getSingleClickResources,
	getSingleClickTypes,
	getNotifications,
	readNotification,
	clearUnreadNotification,
	followCompetitor,
	checkCompetitorFollow,
	unfollowCompetitor
}

function getCompetitors(token) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/competitors/competitors-list/`, requestOptions).then(handleResponse);
}

function getCompetitorById(token, id) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/competitors/competitor/${id}`, requestOptions).then(handleResponse);
}

function getCompetitorProducts(id, token) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/competitors/competitor-products/${id}`, requestOptions).then(handleResponse);
}

function getCompetitorProductById(token, id) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/competitors/competitor-product-by-id/${id}`, requestOptions).then(handleResponse);
}


function getResourceTypes(token) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/resources/resource-types/`, requestOptions).then(handleResponse);
}

function getResourceTypeById(token, id) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/resources/resource-types/${id}`, requestOptions).then(handleResponse);
}

function getResources(comp_prod_id, token) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	}
	return fetch(`${config.apiUrl}/resources/get-resources/?comp_prod_id=${comp_prod_id}`, requestOptions).then(handleResponse);
}

function getSingleClickTypes(token) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	}
	return fetch(`${config.apiUrl}/competitors/competitor-single-click-types/`, requestOptions).then(handleResponse);
}

function getSingleClickResources(token, id) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	};
	return fetch(`${config.apiUrl}/competitors/competitor-single-click-resources/${id}`, requestOptions).then(handleResponse);
}

function submitFeedback(upload_document, form, token) {
	const requestOptions = {
		method: "POST",
		headers: { Authorization: "Bearer " + token },
		body: form
	};
	return fetch(`${config.apiUrl}/competitors/competitor-user-feedback/`, requestOptions).then(handleResponse);
}

function checkCompetitorFollow(token, id) {
	const requestOptions = {
		method: "GET",
		headers: {
			Authorization: "Bearer " + token
		},
	}
	return fetch(`${config.apiUrl}/competitors/competitor-user-following/` + id + '/status', requestOptions).then(handleResponse);
}

function followCompetitor(token, data) {
	const requestOptions = {
		method: "POST",
		headers: {
			Authorization: "Bearer " + token,
			"Content-Type": "application/json",
		},
		body: data
	};
	return fetch(`${config.apiUrl}/competitors/competitor-user-following/follow`, requestOptions).then(handleResponse);
}

function unfollowCompetitor(token, data) {
	const requestOptions = {
		headers: {
			Authorization: "Bearer " + token,
			"Content-Type": "application/json",
		},
		method: "POST",
		body: data
	};
	return fetch(`${config.apiUrl}/competitors/competitor-user-following/follow`, requestOptions).then(handleResponse);
}

function getNotifications(token) {
	const requestOptions = {
		method: "GET",
		headers: { Authorization: "Bearer " + token },
	}
	return fetch(`${config.apiUrl}/competitors/notifications/`, requestOptions).then(handleResponse);
}

function readNotification(token, id) {
	const requestOptions = {
		method: "PATCH",
		headers: { Authorization: "Bearer " + token },
	}
	return fetch(`${config.apiUrl}/competitors/notifications/` + id + "/read", requestOptions).then(handleResponse);
}

function clearUnreadNotification(token) {
	const requestOptions = {
		method: "PATCH",
		headers: { Authorization: "Bearer " + token },
	}
	return fetch(`${config.apiUrl}/competitors/notifications/clear-unread`, requestOptions).then(handleResponse);
}